import { Component, OnInit, Inject, Injectable } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ActiveService } from "../../../view/services/active.service";
import { FormService } from "../../services/forms/form.service";
import { FieldFormService } from "../../services/forms/field-form.service";
import { MapService } from "../../../view/services/map.service";
import { LoginService } from "../../services/login/login.service";
import { ObjectTypesService } from "../../services/forms/object-types.service";

@Component({
  selector: "app-modal",
  templateUrl: "./modal.component.html",
  styleUrls: ["./modal.component.css"],
})
export class ModalComponent implements OnInit {
  name: any;
  scene: any;
  lat: any;
  lng: any;
  posX: any;
  posY: any;
  formId: any;
  fields: any;
  formcapId: number[];
  valuesCampo: string[];
  usuarioId: number;
  fieldTypes: any;
  optionsField: string[][];

  constructor(
    protected mapService: MapService,
    protected loginService: LoginService,
    protected formService: FormService,
    protected fieldFormService: FieldFormService,
    protected activeService: ActiveService,
    protected objectTypesService: ObjectTypesService,
    private dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.scene = data.scene;
    this.lat = data.lat;
    this.lng = data.lng;
    this.posX = data.posX;
    this.posY = data.posY;
    this.formcapId = [];
    this.valuesCampo = [];
    this.formId = mapService.getCurrentFormId();
    this.usuarioId = loginService.getuserId();
    this.objectTypesService.getObjectTypes().subscribe((data: {}) => {
      this.fieldTypes = data;
      this.getFields();
    });

    if (this.formId === "") {
      this.dialogRef.close();
      alert(
        "No se ha seleccionado ningún formulario para la creación del activo"
      );
    }
  }

  ngOnInit() { }

  public closeMe() {
    this.dialogRef.close();
  }
  //this is used to retrieve the current date in YYYY-MM-DD format
  getCurrentDate() {
    const now = new Date();
    const year = now.getFullYear();
    const month = ('0' + (now.getMonth() + 1)).slice(-2);
    const day = ('0' + now.getDate()).slice(-2);
    const currentDate = year + '-' + month + '-' + day;
    return currentDate;
  }

  getFields() {
    this.fieldFormService.getFieldForm({ formulario_id: this.formId }).subscribe((dataField: {}) => {
      this.fields = dataField["SDTFormularioid"];
      dataField["SDTFormularioid"].forEach((element) => {
        this.formcapId.push(element["formulario_campo_id"]);
      });
      this.getTypes();
    });
  }

  getTypes() {
    this.fields.forEach((element, index) => {
      for (let index2 = 0; index2 < this.fieldTypes.length; index2++) {
        const element2 = this.fieldTypes[index2];
        if (element["tipo_objeto_id"] == element2["tipo_objeto_id"]) {
          var typeconvert;
          switch (element2["tipo_objeto_icono"]) {
            case "text_fields":
              typeconvert = "text";
              break;

            case "numbers":
              typeconvert = "number";
              break;

            case "list":
              typeconvert = "combo";
              this.fields[index].options = this.getOptionsField(element["formulario_campo_id"]);
              break;

            case "event":
              typeconvert = "date";
              break;

            case "image":
              typeconvert = "text"; //CAMBIAR PARA QUE SEA UN FILESELECT
              break;

            default:
              break;
          }
          this.fields[index].type = typeconvert;
        }
      }
    });
  }

  getOptionsField(id): string[] {
    var options = [];
    this.fieldFormService.getOptions(id).subscribe((data: []) => {
      data.forEach(element => {
        options[element["formulario_campo_opcion_orden"]] = element["formulario_campo_opcion_valor"];
      });

    });
    return options;
  }

  public createActive() {
    const activeDetails = {
      formulario_captura_scene: this.scene,
      formulario_captura_latitud: this.lat,
      formulario_captura_longitud: this.lng,
      formulario_captura_x: this.posX,
      formulario_captura_y: this.posY,
      formulario_captura_altitud: "2600", //De donde obtener la altitud?
      formulario_captura_estado: 1, //Estado?
      formulario_captura_fecha: this.getCurrentDate(),
      formulario_id: this.formId,
      usuario_realgisId: this.usuarioId, //Usuario login   
    };
    this.activeService.createActive(activeDetails).subscribe((data: {}) => {
      this.dialogRef.close({ data: data });
      this.createCapture(data);
    });
  }

  createCapture(data) {
    for (let index = 0; index < this.formcapId.length; index++) {
      const capture = {
        formulario_captura_id: data["formulario_captura_id"],
        formulario_campo_id: this.formcapId[index],
        formulario_captura_campo_valor: this.valuesCampo[index],
      };
      console.log(capture);
      /* this.activeService.createCapture(capture).subscribe((data: {}) => {
        this.dialogRef.close({ data: data });
      }); */
    }
  }

}
